/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_REPORT_TABLE = gql`
query GetApplicationReportTable($criteria: criteriaApplication, $skip: Int, $limit: Int) {
    getApplicationReportTable(criteria: $criteria, skip: $skip, limit: $limit) {
      currentPage
      pageSize
      totalCount
      totalPages
      data
    }
  }
`;